import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const DishDetailsCard = ({ dish, quantity, onQuantityChange }) => {
  const handleIncrement = () => {
    onQuantityChange(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) {
      onQuantityChange(quantity - 1);
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-warm p-4 md:p-6">
      <div className="flex flex-col lg:flex-row gap-4 md:gap-6">
        <div className="w-full lg:w-48 h-48 rounded-lg overflow-hidden flex-shrink-0">
          <Image
            src={dish?.image}
            alt={dish?.imageAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-4">
            <div className="flex-1 min-w-0">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2 line-clamp-2">
                {dish?.name}
              </h2>
              <p className="text-sm md:text-base text-muted-foreground line-clamp-2 mb-3">
                {dish?.description}
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-1.5">
                  <Icon name="Star" size={16} color="var(--color-warning)" />
                  <span className="text-sm font-medium data-text">{dish?.rating}</span>
                  <span className="text-xs text-muted-foreground">({dish?.reviews} reviews)</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
                  <span className="text-sm text-muted-foreground">{dish?.prepTime}</span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start sm:items-end gap-2">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary data-text">
                ${Number(dish?.price_per_plate ?? dish?.price ?? 0).toFixed(2)}
              </div>
              <span className="text-xs md:text-sm text-muted-foreground">per plate</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 mb-4">
            {dish?.tags?.map((tag, index) => (
              <span
                key={index}
                className="inline-flex items-center gap-1.5 px-3 py-1 bg-primary/10 text-primary rounded-full text-xs md:text-sm font-medium"
              >
                <Icon name={tag?.icon} size={14} />
                {tag?.label}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-4 pt-4 border-t border-border">
            <span className="text-sm md:text-base font-medium text-foreground">Quantity:</span>
            <div className="flex items-center gap-3">
              <button
                onClick={handleDecrement}
                disabled={quantity <= 1}
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-input hover:bg-muted transition-smooth disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Icon name="Minus" size={18} />
              </button>
              <span className="text-lg md:text-xl font-heading font-bold data-text min-w-[3rem] text-center">
                {quantity}
              </span>
              <button
                onClick={handleIncrement}
                className="w-10 h-10 flex items-center justify-center rounded-lg border border-input hover:bg-muted transition-smooth"
              >
                <Icon name="Plus" size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DishDetailsCard;